var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('vue-page-transition',{attrs:{"name":"fade"}},[_c('router-view')],1),(_vm.currentRoute)?_c('chat-box'):_vm._e(),_c('vue-progress-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }